import { render, staticRenderFns } from "./DSEllipsisIcon.vue?vue&type=template&id=47fef318&scoped=true&"
import script from "./DSEllipsisIcon.vue?vue&type=script&lang=js&"
export * from "./DSEllipsisIcon.vue?vue&type=script&lang=js&"
import style0 from "./DSEllipsisIcon.vue?vue&type=style&index=0&id=47fef318&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fef318",
  null
  
)

export default component.exports